module.exports = __webpack_public_path__ + "img/1690LOGO.f60e2fe0.png";